import React from "react";
import { Avatar, Box, IconButton, Tooltip } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuIcon from "@mui/icons-material/Menu";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

import Brand from "../Brand";
import Logo from "../Logo";
import { appBarHeight, consoleBorder } from "./constants";

const goHome = () => {
  window.location.href = "/";
};

const DashboardTopBar = ({
  accountSwitcher,
  collapsed,
  currentUser,
  drawerWidth,
  onOpenMobileNav,
  onOpenSearch,
  onOpenUserMenu,
  searchEnabled,
  onToggleCollapsed,
}) => (
  <Box
    sx={{
      position: "fixed",
      left: 0,
      right: 0,
      top: 0,
      zIndex: (theme) => theme.zIndex.drawer + 2,
      height: appBarHeight,
      bgcolor: "#fff",
      borderBottom: `1px solid ${consoleBorder}`,
      boxShadow: "0 1px 3px rgba(60,64,67,0.16)",
      display: "flex",
      alignItems: "stretch",
    }}
  >
    <Box
      sx={{
        width: { xs: "auto", sm: drawerWidth },
        minWidth: { xs: 0, sm: drawerWidth },
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2,
        borderRight: { xs: "none", sm: `1px solid ${consoleBorder}` },
        transition: (theme) =>
          theme.transitions.create(["width", "min-width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.shorter,
          }),
      }}
    >
      <IconButton
        aria-label="open dashboard navigation"
        onClick={onOpenMobileNav}
        sx={{ color: "#5f6368", display: { xs: "inline-flex", sm: "none" } }}
      >
        <MenuIcon />
      </IconButton>
      <Box sx={{ display: "inline-flex", cursor: "pointer" }} onClick={goHome}>
        <Logo mode="light" size={40} />
      </Box>
      {!collapsed && (
        <Box sx={{ display: { xs: "none", sm: "inline-flex" }, cursor: "pointer" }} onClick={goHome}>
          <Brand width={111} height={48} mode="light" />
        </Box>
      )}
      <Tooltip title={collapsed ? "Expand sidebar" : "Collapse sidebar"}>
        <IconButton
          size="small"
          onClick={onToggleCollapsed}
          sx={{
            color: "#5f6368",
            display: { xs: "none", sm: "inline-flex" },
            ml: "auto",
            "&:hover": { bgcolor: "#eef3f8" },
          }}
        >
          {collapsed ? <ChevronRightIcon fontSize="small" /> : <ChevronLeftIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
    </Box>

    <Box
      sx={{
        minWidth: 0,
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: { xs: 1.5, sm: 2 },
      }}
    >
      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        {accountSwitcher}
      </Box>
      {searchEnabled && (
        <Tooltip title="Search contractors">
          <IconButton
            aria-label="search contractors"
            onClick={onOpenSearch}
            sx={{
              color: "#5f6368",
              "&:hover": { bgcolor: "#eef3f8", color: "#1a73e8" },
            }}
          >
            <SearchOutlinedIcon />
          </IconButton>
        </Tooltip>
      )}
      <IconButton
        aria-label="open user menu"
        onClick={onOpenUserMenu}
        edge="end"
        sx={{ color: "#5f6368" }}
      >
        {currentUser?.photoURL ? (
          <Avatar
            alt={currentUser.displayName || "User"}
            src={currentUser.photoURL}
            sx={{ width: 28, height: 28 }}
          />
        ) : (
          <AccountCircleIcon />
        )}
      </IconButton>
    </Box>
  </Box>
);

export default DashboardTopBar;
